<template>
  <div
    v-if="monetize || template.collect_name"
    class="mb-4"
  >
    <label
      v-if="monetize && price > 0"
      for="name"
      class="mb-1 block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
    >{{ $t("holder_name") }}</label>
    <label
      v-else
      for="name"
      class="mb-1 block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
    >{{ $t("name") }}</label>
    <div class="relative">
      <input
        id="name"
        v-model="form.name"
        type="text"
        name="name"
        :placeholder="$t('enter_name')"
        class="block w-full rounded-md border-grayCust-350 shadow-sm focus:border-primary-900 focus:ring-1 focus:ring-primary-900 sm:text-sm"
      >
      <!-- <div class="absolute top-3 right-3">
                    <img :src="cdn('images/loader-icon.svg')" class="animate-spin" alt="loader-icon">
                </div> -->
    </div>
    <p
      v-for="(error,index) in errors.name"
      :key="index"
      class="m-2 text-xs text-red-700"
    >
      {{ error }}
    </p>
  </div>
  <div
    v-if="monetize || template.collect_email"
    class="mb-4"
  >
    <label
      for="email"
      class="mb-1 block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
    >{{
      $t("email_address") }}</label>
    <div class="relative">
      <input
        id="email"
        v-model="form.email"
        type="email"
        name="email"
        :placeholder="$t('enter_your_email_address')"
        class="block w-full rounded-md border-grayCust-350 shadow-sm focus:border-primary-900 focus:ring-1 focus:ring-primary-900 sm:text-sm"
        @blur="checkUser"
      >
      <div class="absolute right-3 top-3">
        <img
          v-if="isSearchingUser == 1"
          :src="cdn('images/loader-icon.svg')"
          class="animate-spin"
          alt="loader-icon"
        >
        <svg
          v-else-if="isSearchingUser == 2"
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8 16.5C12.4183 16.5 16 12.9183 16 8.5C16 4.08172 12.4183 0.5 8 0.5C3.58172 0.5 0 4.08172 0 8.5C0 12.9183 3.58172 16.5 8 16.5ZM11.7071 7.20711C12.0976 6.81658 12.0976 6.18342 11.7071 5.79289C11.3166 5.40237 10.6834 5.40237 10.2929 5.79289L7 9.08579L5.70711 7.79289C5.31658 7.40237 4.68342 7.40237 4.29289 7.79289C3.90237 8.18342 3.90237 8.81658 4.29289 9.20711L6.29289 11.2071C6.68342 11.5976 7.31658 11.5976 7.70711 11.2071L11.7071 7.20711Z"
            fill="#15B881"
          />
        </svg>
      </div>
    </div>
    <p
      v-for="(error,index) in errors.email"
      :key="index"
      class="m-2 text-xs text-red-700"
    >
      {{ error }}
    </p>
  </div>
  <div
    v-if="userExists == 0 && userSearched && template.is_monetized == 1 && form.email !== null && form.email !== ''"
    class="mb-4 flex items-center rounded-lg border-2 border-blueCust-50 bg-blueCust-300 p-4"
    style="border-color:#B2DDFF"
  >
    <ExclamationIcon class="h-10 w-10 text-blueCust-800" />
    <p class="ml-4 text-sm font-medium text-blueCust-800">
      {{ $t('shared_template_account_creation_message') }}
    </p>
  </div>
  <div
    v-else-if="userExists == -1"
    class=" mb-4 flex items-center rounded-lg border-2 border-primary-260 p-4"
    style="background-color:rgba(235, 249, 245, 0.40)"
  >
    <svg
      width="25"
      height="21"
      viewBox="0 0 25 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_20006_106246)">
        <path
          d="M20.4335 7.951H23.8527C23.9104 7.95082 23.9675 7.96588 24.0179 7.99465C24.0682 8.02347 24.1104 8.065 24.1394 8.11506C24.1688 8.16512 24.1841 8.222 24.1844 8.28C24.1848 8.338 24.1699 8.39506 24.1416 8.44547L17.9887 19.3622C17.8951 19.5285 17.759 19.6669 17.5941 19.7634C17.4294 19.8597 17.2422 19.9106 17.0512 19.9108H14.4337C14.2157 19.9108 14.0027 19.8444 13.8234 19.7205C13.6437 19.5966 13.5062 19.4211 13.4289 19.2172L12.7881 17.5334L12.8331 17.5637C13.038 17.6963 13.2677 17.7854 13.5083 17.8254C13.7493 17.8655 13.9957 17.8556 14.2324 17.7965C14.4691 17.7374 14.691 17.6303 14.8849 17.4818C15.0784 17.3334 15.2397 17.1467 15.3581 16.9334L19.0501 10.3218H16.1045C16.0414 10.3231 15.9794 10.3063 15.9255 10.2735C15.8716 10.2406 15.828 10.193 15.8004 10.1364C15.7727 10.0796 15.7618 10.0162 15.7688 9.95353C15.776 9.89088 15.8011 9.83153 15.8408 9.78253L23.2434 0.575985C23.281 0.535531 23.3313 0.509404 23.3859 0.502094C23.4408 0.494783 23.4961 0.506747 23.5429 0.535928C23.5897 0.565108 23.6251 0.609684 23.6425 0.661994C23.6598 0.714303 23.6588 0.77108 23.639 0.822566L20.4335 7.951Z"
          fill="url(#paint0_linear_20006_106246)"
        />
        <path
          d="M8.41193 19.2503C8.41193 19.3369 8.39493 19.4226 8.36164 19.5026C8.32864 19.5826 8.28011 19.6553 8.21882 19.7166C8.15782 19.7778 8.08482 19.8263 8.00505 19.8595C7.92499 19.8926 7.83917 19.9096 7.7527 19.9096H4.94528C4.80918 19.9096 4.67662 19.8676 4.56533 19.7892C4.45404 19.7109 4.37005 19.6 4.32432 19.4719L3.9908 18.5238L0.566309 8.84123C0.530511 8.74058 0.519523 8.63282 0.534054 8.52705C0.548941 8.42123 0.58864 8.32053 0.65031 8.23335C0.711981 8.14611 0.793498 8.075 0.888487 8.02588C0.983116 7.97676 1.08838 7.95111 1.19506 7.95117H3.76007C3.92807 7.95105 4.09217 8.00282 4.23005 8.09929C4.36792 8.19582 4.47247 8.33235 4.52989 8.49047L8.18899 18.5119L8.37652 19.0235C8.40134 19.0965 8.41335 19.1732 8.41193 19.2503Z"
          fill="#056960"
        />
        <path
          d="M11.2589 13.5248L9.14928 19.4876C9.10499 19.6121 9.02311 19.7198 8.91534 19.796C8.80764 19.8722 8.67858 19.9133 8.54675 19.9135H4.9454C4.80894 19.9132 4.67603 19.8706 4.56474 19.7915C4.45345 19.7124 4.36945 19.6007 4.32444 19.4718L3.9895 18.5237C4.05543 18.6318 4.60514 19.4757 5.28955 18.5118L8.80764 8.87542C8.80764 8.87542 9.22975 8.61959 9.48811 8.87542L11.2589 13.5248Z"
          fill="#0D4943"
        />
        <path
          d="M16.017 15.7613L14.4257 18.6055C14.3604 18.7219 14.2637 18.8173 14.1464 18.8804C14.0287 18.9436 13.8958 18.9719 13.7629 18.9621C13.63 18.9522 13.5024 18.9046 13.3957 18.8249C13.289 18.7452 13.2071 18.6366 13.1596 18.5119L11.2596 13.5249L9.55333 9.04165C9.51644 8.94753 9.44768 8.86947 9.35874 8.82117C9.27015 8.77294 9.16697 8.75759 9.06809 8.77794C8.97562 8.79729 8.88627 8.83106 8.80444 8.87817C8.89162 8.63417 9.04615 8.41982 9.24991 8.2597C9.49874 8.06029 9.80815 7.95153 10.1268 7.95117H12.4795C12.7237 7.95065 12.9619 8.02541 13.1621 8.16535C13.362 8.30529 13.5141 8.50359 13.5974 8.73312L16.0408 15.4238C16.0617 15.4784 16.0702 15.5369 16.0663 15.5951C16.0621 15.6534 16.0454 15.7101 16.017 15.7613Z"
          fill="#056960"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_20006_106246"
          x1="17.999"
          y1="16.9706"
          x2="22.999"
          y2="0.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FE8551" />
          <stop
            offset="1"
            stop-color="#ED618E"
          />
        </linearGradient>
        <clipPath id="clip0_20006_106246">
          <rect
            width="24.7059"
            height="20"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>

    <p class="ml-4 max-w-[320px] text-sm font-medium text-primary-900">
      {{
        $t('shared_template_account_login_message') }}
    </p>
    <button
      class="inline-flex items-center rounded-lg border border-primary-900 bg-primary-900 px-3 py-2.5 text-xs font-medium text-white shadow-sm focus:ring-2 focus:ring-primary-900 focus:ring-offset-2"
      @click="isLoginModal = true"
    >
      {{ $t('login_now') }}
      <svg
        width="20"
        class="ml-2"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.8333 6.33398L15 10.5007M15 10.5007L10.8333 14.6673M15 10.5007L5 10.5007"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </div>
  <!-- <div>
            <legend class="block text-sm font-medium text-grayCust-800 mb-1">Added Cards</legend>
            <button @click="addCardClick" class="w-full py-3 border mb-4 border-grayCust-160 rounded-lg text-grayCust-1740 lg:text-base text-sm inline-flex items-center justify-center font-semibold focus:ring-0 focus:outline-0">
                <img src="/images/MarketPlace/Dashboard/card-add.svg" class="mr-2"> Add card
            </button>
        </div> -->
  <div
    v-if="price > 0 && cards && cards.length > 0"
    class="mb-4"
  >
    <div class="flex items-center justify-between">
      <legend class="block text-sm font-medium text-grayCust-800">
        {{ $t('added_cards') }}
      </legend>
      <div class="flex items-center">
        <!-- <button class="text-sm font-medium text-grayCust-600">
                            Edit
                    </button> -->
        <button
          v-if="false"
          class="ml-5 text-sm font-medium text-grayCust-600"
          @click="addCardClick"
        >
          Add Card
        </button>
      </div>
    </div>
    <div class="custom-scroll mt-1 grid max-h-72 grid-cols-1 gap-3 overflow-auto p-1 pr-2 md:grid-cols-2">
      <div
        v-for="card in cards"
        class="relative"
      >
        <input
          :id="'card_'+card.id"
          v-model="form.payment_method"
          type="radio"
          class="planRadio size-4 border-gray-300 bg-primary-100 text-primary-900 focus:ring-2 focus:ring-primary-900"
          :value="card.id"
        >
        <label
          :for="'card_'+card.id"
          class="selectCard flex items-center justify-between rounded-lg border border-grayCust-350 bg-grayCust-50 p-4 focus:ring-2 focus:ring-primary-900"
        >
          <div class="flex">
            <component
              :is="card.card.brand"
              v-if="card.card.brand != 'American Express'"
            />
            <div class="ml-4">
              <h3 class="text-sm text-grayCust-800"><span
                class="mr-0.5"
              >{{ card.card.brand }}</span>****<span
                class="ml-0.5"
              >{{ card.card.last4 }}</span></h3>
              <h3 class="mt-2 text-sm text-grayCust-400">Expires
                {{ card.card.exp_month }}/{{ card.card.exp_year }}</h3>
            </div>
          </div>
        </label>
      </div>
    </div>
  </div>
  <div
    v-if="price > 0 && cards.length == 0"
    class="mb-4"
  >
    <div class="relative">
      <div>
        <label
          for="card-number"
          class="mb-1 block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
        >{{
          $t('credit_card') }}</label>
        <div
          id="card-element"
          class="flex h-10 w-full items-center rounded-md border border-solid border-grayCust-350 px-5 shadow-sm focus:border-primary-900 focus:ring-1 focus:ring-primary-900 sm:text-sm"
        />
        <p
          v-show="errors.payment_method != undefined"
          class="ml-1 mt-1 text-xs text-red-600"
        >
          {{ errors.payment_method }}
        </p>
      </div>
      <div class="mt-2 text-sm font-normal text-grayCust-550">
        {{
          $t("your_card_will_be_charged", {
            price: price,
            paymentInterval:
              interval == "" ? '' : (interval == "monthly"
                ? " every month"
                : " every year"),
          })
        }}
      </div>
    </div>
  </div>
  <div v-if="price > 0">
    <div
      v-if="isEmailVerificationMain"
      class="mb-4 text-center text-base font-normal text-grayCust-500 "
    >
      We have
      sent a verification email. <span
        class="cursor-pointer font-medium text-primary-900"
        @click="isEmailVerification = true,isEmailVerificationMain = false"
      >Click to Verify</span>
    </div>
    <div
      v-if="isEmailVerification"
      class="mb-4 text-center text-base font-normal text-grayCust-500 "
    >
      Email
      verification failed, try again <span
        class="cursor-pointer font-medium text-primary-900"
        @click="isEmailVerificationMain = true,isEmailVerification = false"
      >Retry</span>
    </div>
  </div>


  <fieldset className="space-y-5">
    <div className="relative flex items-center">
      <div
        v-if="!template.hide_privacy_checkbox"
        className="flex h-5 items-center"
      >
        <input
          id="privacy"
          v-model="form.subscribe_newsletter"
          type="checkbox"
          className="h-4 -mt-1 sm2:-mt-0 w-4 rounded border-gray-300 text-primary-900 focus:ring-primary-900"
        >
      </div>
      <label
        v-if="template.custom_privacy_text && template.custom_privacy_text !== '<p><br></p>'"
        for="privacy"
        class="-mt-0.5 ml-2 cursor-pointer text-sm font-normal text-gray-700 sm2:text-base"
        v-html="template.custom_privacy_text"
      />
      <label
        v-else-if="!template.hide_privacy_checkbox"
        for="privacy"
        class="-mt-0.5 ml-2 cursor-pointer text-sm font-normal text-gray-700 sm2:text-base"
      >{{ $t('subscribe_mailing_list') }}<a
        target="_blank"
        href="https://instawp.io/privacy/"
        class="btn-focus pl-2 focus:outline-0 focus-visible:outline-0"
      >{{
        $t('privacy_policy') }}</a></label>
      <label
        v-else
        for="privacy"
        class="-mt-0.5 ml-2 cursor-pointer text-sm font-normal text-gray-700 sm2:text-base"
      >{{ $t('agree_to_our') }} <a
        target="_blank"
        href="https://instawp.io/privacy/"
        class="focus:outline-0"
      >{{ $t('privacy_policy') }}</a> {{
        $t('entering_your_email') }}</label>
    </div>
  </fieldset>

  <loginModal
    :email="form.email"
    :is-login-modal="isLoginModal"
    :is-modal-login="'true'"
    @close_login_modal="closeLoginModal"
  />
</template>

<script>
import ExclamationIcon from '@/Common/ExclamationIcon.vue';
import Americanexpress from '@/components/UpdatedDesignVersion/ImageComponents/Profile/AmericanExpress.vue';
import Discover from '@/components/UpdatedDesignVersion/ImageComponents/Profile/Discover.vue';
import Mastercard from '@/components/UpdatedDesignVersion/ImageComponents/Profile/MasterCard.vue';
import Visa from '@/components/UpdatedDesignVersion/ImageComponents/Profile/Visa.vue';

import loginModal from '@/components/Template/SharedLaunch/loginModal.vue';

export default {
    name: "ExclamationIcon",
    
    components: {
        ExclamationIcon,
        Visa, Mastercard,
        Americanexpress,
        Discover,
        loginModal
    },
    props:{
        price: {
            default: 0,
            type: Number,
        },
        monetize: {
            default: false,
            type: Boolean,
        },
        interval: {
            default: '',
            type: String,
        },
        template: {
            required: true,
            type: Object,
        },
        form: {
            type: Object,
            default: {
                name: "",
                email: "",
            }
        },
        isUserExist: {
            type: Number,
            default: 0,
        },
        errors: {
            type: Object,
            default: {
                name: "",
                email: "",
            }
        },
        cards: {
            type: Array,
            required:false,
        }
    },
    emits: ['click_add_card'],
    data() {
        return {
            showLogIn: false,
            isLoginModal: false,
            userExists: this.isUserExist,
            cards: [],
            isSearchingUser: 0,
            userSearched: false,
        }
    },
    mounted(){
        if (this.template.is_monetized && this.isUserExist == 1) {
            this.listCard();
        }            
    },
    methods:{
        checkUser(){
            if (this.template.is_monetized && this.userExists != 1) {
                const that = this;
                that.isSearchingUser = 1;
                axios
                .post(`/api/v2/check-user`, {'email' : that.form.email })
                .then((response) => {
                    that.form.user_id = response.data.data.id;
                    that.userExists = -1;
                })
                .catch((error) => {
                    that.form.user_id = null;
                    that.userExists = 0;
                }).finally(() => {
                    that.isSearchingUser = 2;
                    that.userSearched = true;
                })
            }
        },
        listCard() {
            if(this.template.product.price > 0) {
                const that = this;
                axios
                    .get("/list-source")
                    .then((response) => {
                        that.cards = response.data.data.card.list;
                        that.form.payment_method = response.data.data.card.default_source;
                    })
                    .catch((error) => {
                    })
                    .finally(() => {
                    });
            }
        },
        closeLoginModal(userId = ''){
            this.form.user_id = userId;
            this.isLoginModal = false;
            if (this.template.is_monetized && userId != '') {
                this.userExists = 1;
                this.listCard();
            }            
        },
        addCardClick(){
            this.$emit("click_add_card")
        }
    }
    
}
</script>
<style scoped>
.btn-focus:focus-visible{
    outline: 0 !important;
}
.planRadio {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translate(-50%, -50%);
}

.planRadio:checked~.selectCard {
    border-color: #005e54;
    box-shadow: 0px 2px 4px #70D9B6, 0px -2px 4px #70D9B6;
}
.custom-scroll::-webkit-scrollbar {
    width: 3px;
}

.custom-scroll::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 8px;
}

.custom-scroll::-webkit-scrollbar-thumb {
    background: #005E54;
    border-radius: 8px;
}
</style>
